import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ArquivoFilter } from '../../filter';
import { Subscription } from 'rxjs';
import { NgModel } from '@angular/forms';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
    selector: 'sgt-arquivo-card-filter',
    templateUrl: './arquivo-card-filter.component.html',
    styleUrls: ['./arquivo-card-filter.component.less']
})
export class ArquicoCardFilterComponent implements OnInit, OnDestroy {
    // Filter
    @Input() filter: ArquivoFilter;
    isFilterInitializing = false;
    isFilterInitialized = false;
    @Output() filterInitialized = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() filterCleaned = new EventEmitter<any>();
    // Filter pesquisa
    filterPsqSubscription: Subscription;
    isFirstChangeFilterPsq = true;
    @ViewChild('filterPsq', {static: true}) filterPsq: NgModel;

    // Multiselects
    /** Se deve exibir os multiselect em dropup */
    @Input() dropupMultiselects = false;
    isFirstChangeTiposArquivos = true;
    isFirstChangeUsuariosCreated = true;

    ngOnInit(): void {
        this.initFilter();
    }

    /** Inicializa o filtro */
    private initFilter() {
        this.isFilterInitializing = true;
        this.isFilterInitialized = false;

        // Filter de pesquisa
        this.subscribeToFilterPsq();

        setTimeout(() => {
            this.isFilterInitializing = false;
            this.isFilterInitialized = true;
            this.filterInitialized.emit();
        }, 0);
    }

    // Realiza o subscribe nas alterações feitas no input do filtro da pesquisa
    private subscribeToFilterPsq() {
        this.filterPsqSubscription = this.filterPsq.valueChanges
            .pipe(
                debounceTime(1000), // Dando um debounce de 1000ms para emitir a alteração
                map(emittedValue => emittedValue?.trim()),
                distinctUntilChanged()
            )
            .subscribe(() => {
                if (this.isFirstChangeFilterPsq) {
                    this.isFirstChangeFilterPsq = false;
                    return;
                }

                if (this.filter.filterPsq?.trim().length > 0) {
                    this.filter.isFilterDirty = true;
                }

                this.filterChange.emit();
            });
    }

    /** Ao alterar os tipos de arquivos */
    onChangeTiposArquivos() {
        if (this.isFirstChangeTiposArquivos) {
            this.isFirstChangeTiposArquivos = false;
            return;
        }

        this.filterChange.emit();
    }

    /** Ao alterar os usuários created */
    onChangeUsuariosCreated() {
        if (this.isFirstChangeUsuariosCreated) {
            this.isFirstChangeUsuariosCreated = false;
            return;
        }

        this.filterChange.emit();
    }

    /** Limpa o filtro */
    clear() {
        this.filter.clear();
        setTimeout(() => this.filterCleaned.emit(), 0);
    }

    ngOnDestroy() {
        this.filterPsqSubscription?.unsubscribe();
    }
}
